import styled, { css } from 'styled-components'
// components
import { Collapse as CollapseOrigin } from 'components/UI'
// themes
import { colors } from 'themes/index'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { AddFieldButtonWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/AddFieldButton/views'
// utils
import { isColorLight } from 'utils/tree'

export const SectionWrapper = styled.div<{ $color: string }>`
  border: 2px solid ${({ $color }) => $color};
  border-radius: 6px;

  ${AddFieldButtonWrapper} {
    margin-left: 16px;
  }

  ${ButtonsWrapper} {
    right: 4px;
  }
`

export const SectionName = styled.div<{ $color: string; $disabled: boolean }>`
  font-size: 20px;
  color: ${({ $color }) => (isColorLight($color) ? colors.black : colors.white)};
  margin-left: ${({ $disabled }) => ($disabled ? 12 : 0)}px;
`

export const Content = styled.div<{ $color: string; $height: number; $isCollapsed: boolean }>`
  width: 100%;
  min-height: ${({ $height }) => $height || 50}px;
  padding: 0 12px 12px;
  position: relative;

  ${({ $isCollapsed, $color }) =>
    $isCollapsed &&
    css<{ $color: string }>`
      padding: 0 12px 0;
      background-color: ${$color};
    `};

  > div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`

export const Collapse = styled(CollapseOrigin)<{ $color: string }>`
  background: ${({ $color }) => $color};
  padding: 8px;
  margin: 0 -14px;
  border-radius: 6px 6px 0 0;
  cursor: pointer;

  svg {
    fill: ${({ $color }) => (isColorLight($color) ? colors.black : colors.white)};
  }
`
